import { useEffect } from 'react';
import { notifyBanner, clearBanner } from '@providers/top-banner';
import { apolloClient } from '../../apollo-client';

export const ConnectionRecovery: React.FC = () => {
    useEffect(() => {
        const onOffline = () => {
            notifyBanner({
                level: 'warning',
                header: 'Offline',
                description: 'We’ll retry automatically when you’re back online.',
            });
        };
        const onOnline = () => {
            notifyBanner({ level: 'info', description: 'Back online. Syncing data…' });
            apolloClient.reFetchObservableQueries().finally(() => clearBanner());
        };
        window.addEventListener('offline', onOffline);
        window.addEventListener('online', onOnline);
        return () => {
            window.removeEventListener('offline', onOffline);
            window.removeEventListener('online', onOnline);
        };
    }, []);
    return null;
};
